export default "__VITE_ASSET__B10LNoTw__"